import React from 'react';
import SettingsBreadcrumb from '@/components/settings/SettingsBreadcrumb';
import SettingsNavigation from '@/components/settings/SettingsNavigation';

export default function SettingsLayout({
  eyebrow = 'Impostazioni',
  title,
  description,
  breadcrumbs,
  current,
  navigation,
  children,
  className = '',
  testId,
}) {
  return (
    <div className={`mx-auto w-full max-w-6xl space-y-5 px-4 pb-10 pt-5 sm:px-6 lg:px-8 ${className}`} data-testid={testId}>
      <header>
        <SettingsBreadcrumb items={breadcrumbs} current={current} />
        <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-green">{eyebrow}</div>
        <h1 className="mt-1 font-display text-3xl font-semibold tracking-tight text-brand-navy md:text-4xl">{title}</h1>
        {description && <p className="mt-1 max-w-2xl text-sm text-stone-500">{description}</p>}
      </header>
      <SettingsNavigation items={navigation} />
      {children}
    </div>
  );
}